module.exports = __webpack_public_path__ + "static/media/wallet.75ac449a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wallet.svg
// module id = 982
// module chunks = 7